const NOSTO_TIMEOUT_MS = 4000

class PushCartRecs extends window.BAO.CustomElement() {
  connectedCallback () {
    super.connectedCallback()

    this.waitForNosto()
  }

  setupListeners () {
    super.setupListeners()

    this.waitForNosto = this.waitForNosto.bind(this)

    window.BAO.eventBus.addEventListener(
      window.BAO.EVENTS.PUSH_CART.SETTLED,
      this.waitForNosto,
    )

    if (typeof window.nostojs === 'function') {
      window.nostojs((api) =>
        api.listen('postrender', this.onPostRender.bind(this)),
      )
    }
  }

  disconnectedCallback () {
    super.disconnectedCallback()

    window.BAO.eventBus.removeEventListener(
      window.BAO.EVENTS.PUSH_CART.SETTLED,
      this.waitForNosto,
    )

    clearTimeout(this.timeout)
  }

  waitForNosto () {
    clearTimeout(this.timeout)

    this.body
      .querySelectorAll('[data-nosto-filled]')
      .forEach((element) => element.removeAttribute('data-nosto-filled'))

    if (
      typeof window.nostojs !== 'function' ||
      !this.body.querySelector('.nosto_element')
    ) {
      this.setReady()
      return
    }

    this.removeAttribute('data-nosto-ready')
    this.timeout = setTimeout(this.setReady.bind(this), NOSTO_TIMEOUT_MS)
  }

  onPostRender ({ filledElements = [], unFilledElements = [] } = {}) {
    const getPlacement = (id) => this.body.querySelector(`#${CSS.escape(id)}`)
    const filledPlacements = filledElements.map(getPlacement).filter(Boolean)
    const unFilledPlacements = unFilledElements
      .map(getPlacement)
      .filter(Boolean)
    const isOurs = filledPlacements.length || unFilledPlacements.length

    if (!isOurs) return

    unFilledPlacements.forEach((element) =>
      element.removeAttribute('data-nosto-filled'),
    )
    filledPlacements.forEach((element) =>
      element.setAttribute('data-nosto-filled', ''),
    )

    this.setReady()
  }

  get body () {
    return this.closest('.psh-Cart_Body') || this
  }

  setReady () {
    clearTimeout(this.timeout)
    this.setAttribute('data-nosto-ready', '')
  }
}

if (!customElements.get('push-cart-recs')) {
  customElements.define('push-cart-recs', PushCartRecs)
}
